import React, { useState } from 'react'
import { Container, TargetDataWrapper } from './TargetStyle'
import { TargetTitle } from 'src/components/Global/Text/TitleText'
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import { GeneralCard } from 'src/components/Global/Cards/Cards'
import { CardBtnWrapper, TransactionContainer } from './TargetStyle'
import { TargetToggle } from './TargetToggle'
import { Link } from 'react-router-dom'
import useUserData from 'src/hooks/useUserData'
import CardCarousel from '../GeneralSavings/Carousel/CardCarousel'
import { LinkArrowSvg } from 'src/assets'
import { Balance, TrendSvg } from 'src/assets'
import {
  FlexContainerOne,
  FlexContainerTwo,
  SavingsFlexWrapper,
} from '../EmergencySavings/EmergencyStyle'
import { CallToActionCard } from 'src/Pages/HomePage/homePageStyle'
import { useTypedSelector } from 'src/redux/index'
import { CreateButton } from 'src/components/Global/Button/Button'
import { TargetNameModal } from 'src/components/HomePage/ModalsContent/createTargetPlans/plans-redux-modal/PlanName'
interface ICardData {
  id: number
  Icon: any
  balance: string
  title: string
  className: string
}

const Target = () => {
  const [showModal, setShowModal] = useState(false)

  const USER_DATA: any = useUserData()
  const accounts = USER_DATA.user.accounts
  const investmentData = useTypedSelector((state) => state.invest.all?.plans!)
  const recent = investmentData?.slice(1, 2)

  const createPlan = (e: any) => {
    e.preventDefault()
    setShowModal(true)
  }
  const portfolio = useTypedSelector(
    (state) => state.portfolios.portfolio.accounts
  )
  const CardData: ICardData[] = [
    {
      id: 1,
      balance: portfolio?.saving_plans.target,
      title: 'Target Balance',
      Icon: Balance,
      className: 'card_one',
    },
    {
      id: 2,
      Icon: TrendSvg,
      balance: portfolio?.total_interest,
      title: 'Interests on savings',
      className: 'card_two',
    },
  ]
  return (
    <Container>
      <TargetTitle className="targetTitle">Target Savings</TargetTitle>
      <SavingsFlexWrapper>
        <FlexContainerOne>
          <CardBtnWrapper>
            <CardCarousel>
              {CardData.map(({ id, Icon, title, balance, className }) => {
                return (
                  <GeneralCard key={id} className={className}>
                    <div className="flex_wrapper">
                      <div className="icon_wrapper">
                        <img src={Icon} alt="" />
                      </div>
                      <div className="balance-wrapper">
                        <p className="title">{title}</p>
                        <h2 className="balance">{balance}</h2>
                      </div>
                    </div>
                  </GeneralCard>
                )
              })}
            </CardCarousel>
          </CardBtnWrapper>
          <div className="fixed-width">
            <TransactionContainer>
              <div className="web-transaction">
                <TargetDataWrapper>
                  <TargetNameModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                  />
                  <CreateButton onClick={createPlan} className="button">
                    Create
                  </CreateButton>
                  <div className="heading">
                    <TargetTitle className="targetTitle">
                      My Targets
                    </TargetTitle>
                  </div>
                  <div className="target-btn-container">
                    <TargetToggle />
                  </div>
                </TargetDataWrapper>
              </div>
            </TransactionContainer>
          </div>
        </FlexContainerOne>

        <FlexContainerTwo>
          {recent?.map((item: any) => (
            <CallToActionCard>
              <div className="header_img">
                <img src={item.image} alt="" className="image" />
              </div>

              <div className="card_body">
                <div className="title_user">
                  <p>{item.plan_name}</p>
                </div>

                <div className="card_text_link">
                  <p>{item.description.substring(0, 60)}...</p>
                  <Link to="/invest" className="call_to_action_link">
                    Join other investors
                    <span>
                      <img src={LinkArrowSvg} alt="" />
                    </span>
                  </Link>
                </div>
              </div>
            </CallToActionCard>
          ))}
        </FlexContainerTwo>
      </SavingsFlexWrapper>
    </Container>
  )
}

export { Target }
